// @flow

import React from 'react';
import gql from 'graphql-tag';

import { isBrowser } from '@zapier/common-utils';

import ApolloQuery from 'web-ssr/app/common/components/ApolloQuery';
import accountFragment from 'web-ssr/rest/fragments/accounts';
import profileFragment from 'web-ssr/rest/fragments/profiles';

import type { ApolloError } from 'apollo-client';
import type { Node } from 'react';

import type { AccountResponse } from 'web-ssr/rest/fragments/accounts';
import type { ProfileResponse } from 'web-ssr/rest/fragments/profiles';

export type CurrentUserQuery = {
  plans: ProfileResponse,
  accounts: AccountResponse,
};

type Result = {
  data: ?CurrentUserQuery,
  error?: ApolloError,
  isStaff: boolean,
  loading: boolean,
  refetch: (variables?: {}) => Promise<any>,
};

export const currentUserQuery = gql`
  ${accountFragment}
  ${profileFragment}

  query currentUser {
    accounts @rest(type: "Account", path: "/v3/accounts") {
      ...AccountFragment
    }

    profiles @rest(type: "Profile", path: "/v3/profiles") {
      ...ProfileFragment
    }
  }
`;

type Props = {
  children: (result: Result) => Node,
};

export const WithCurrentUser = (props: Props) => {
  return (
    <ApolloQuery query={currentUserQuery} skip={!isBrowser()}>
      {result => {
        const { data = {} } = result;
        const { profiles } = data;
        const profileObjects = (profiles && profiles.objects) || [];
        const isStaff = profileObjects.some(profile => profile.is_staff);

        return props.children({ ...result, isStaff });
      }}
    </ApolloQuery>
  );
};

export default WithCurrentUser;
